export default "__VITE_PUBLIC_ASSET__a51aec60__"